<div layout-vertical padding-large layout-justify-center layout-align-items-center margin-large>
  <rt-heading variant="heading" margin-bottom-small-x>
    {{ 'app.interview.empty_template_title' | translate }}
  </rt-heading>
  <rt-heading variant="subheading" margin-bottom>
    {{ 'app.interview.empty_template_description' | translate }}
  </rt-heading>
</div>
